import React from 'react';

interface IAdminLinkTabs{
  children?:any
}
const AdminLinkTabs = ({ children }:IAdminLinkTabs) => (
  <div>{children}</div>
);
export default AdminLinkTabs;
